import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormlyFieldConfig, } from '@ngx-formly/core';
import { SimulationService } from '../../services/simulation.service';
import { MessageService } from 'primeng/api';
import { ExportService } from '../../services/export.service';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { Store } from '@ngxs/store';
import { Severity } from 'src/app/global/enums/severity';

@Component({
  selector: 'app-simulation-bulk-export',
  templateUrl: './simulation-bulk-export.component.html',
  styleUrl: './simulation-bulk-export.component.scss',
  standalone: false,
})
export class SimulationBulkExportComponent implements OnInit {

  constructor(
    private readonly fb: FormBuilder,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly simulationService: SimulationService,
    readonly messageService: MessageService,
    readonly exportService: ExportService,
    private readonly store: Store
  ) {
    this.form = this.fb.group({});
  }

  exportsFields: FormlyFieldConfig[] = [];
  form: FormGroup;
  model: any = {};
  //options: FormlyFormOptions = {};
  mapTypes: any[] = [
    {
      value: 'GeoTiff',
      label: 'Geo Tiff'
    },
    {
      value: 'LandslideSummaryTable',
      label: 'Landslide Summary Table'
    },
    {
      value: 'LandslideToPoints',
      label: 'Landslide to Points'
    }
  ];

  scenarioId: string = '';
  simulationId: string = '';
  simulationName: string = '';

  ngOnInit(): void {
    this.initializeFields();
    this.scenarioId = this.config?.data?.data;
  }

  get fileTypesControl(): FormControl {
    return this.form.get('fileTypes') as FormControl;
  }

  initializeFields(): void {
    this.form = this.fb.group({
      fileTypes: ['GeoTiff', Validators.required]
    });
  }


  async onSave(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const exportedData: any = {
      simulationIds: this.scenarioId,
      fileTypes: [this.fileTypesControl.value]
    }

    const zipFileName = `${exportedData.fileTypes[0]}_SimulationResults_${Date.now()}.zip`;

    // 1) Ask where to save (user gesture)
    let handle: FileSystemFileHandle | null = null;
    try {
      if ('showSaveFilePicker' in window) {
        handle = await (window as any).showSaveFilePicker({
          suggestedName: zipFileName,
          types: [{ description: 'ZIP archive', accept: { 'application/zip': ['.zip'] } }],
        });
      }
    } catch (err: any) {
      // User canceled: no error toast; just bail out quietly
      if (err?.name === 'AbortError') return;

      // Picker blocked or unsupported: proceed without handle → fallback later
      handle = null;
    }

    // 2) Close the dialog AFTER picker to avoid losing activation before it opens
    this.ref.close();

    this.exportService.exportSelectedSimulationByTypes(exportedData).subscribe({
      next: async (response: Blob) => {
        const zipBlob = new Blob([response], { type: 'application/zip' });

        // 4) Write to chosen location or fallback
        if (handle) {
          try {
            const writable = await handle.createWritable();
            await writable.write(zipBlob);
            await writable.close();

            this.store.dispatch(new NotificationsActions.Toast(
              'Export completed successfully.',
              Severity.Success
            ));
          } catch (error) {
            // If writing fails (disk error, permissions), fallback
            await this.exportService.downloadFile(zipBlob, zipFileName);
            this.store.dispatch(new NotificationsActions.Toast(
              'An error occurred while exporting the simulation results.',
              Severity.Error
            ));
          }
        } else {
          // No handle (unsupported or blocked): fallback
          await this.exportService.downloadFile(zipBlob, zipFileName);
          this.store.dispatch(new NotificationsActions.Toast(
            'Export completed (downloaded).',
            Severity.Success
          ));
        }
      },
      error: () => {
        this.store.dispatch(new NotificationsActions.Toast(
          'An error occurred while exporting the simulation results.',
          Severity.Error
        ));
      }
    });
  }


  onCancel(): void {
    this.ref.close(); // ✅ close without data
  }
}
